module.exports = __webpack_public_path__ + "static/img/H3P.8fd6295c.png";